var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Arrow","d":"M4.116-30V7.224L1.248,4.359,0,5.606l5,5,5-5L8.752,4.362,5.875,7.241V-30Z","transform":"translate(30 10) rotate(-90)","fill":"#e11e37","opacity":"0.998"}));
}

RightArrow.defaultProps = {"width":"40.607","height":"10","viewBox":"0 0 40.607 10"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
